<template>
  <div>
    <vs-divider />
    <h5 class="mt-4 mb-2">Elaboration questions</h5>
    <MeetingStepQuestions :questions="step.elaborationQuestions" />
  </div>
</template>

<script>
import MeetingStepQuestions from "../MeetingStepQuestions.vue";
export default {
  components: {
    MeetingStepQuestions
  },
  props: {
    step: {
      type: Object,
      required: true
    }
  },
  created() {
    this.step.elaborationQuestions = this.step.elaborationQuestions || [];
  }
};
</script>